/* Smart Square smart search v2: typo-tolerant, synonyms, Arabic/Franco, price intent */
/* Smart Square smart search core: typo-tolerant, synonym-aware, Arabic/Franco aware, price intent.
   Pure functions; works in browser (window.SSSmart) and node (module.exports). */
(function (root) {
  var STOP = ('i im want wanna need looking look for search show me find give get a an the some something thing things ' +
    'to my me with and or of in on at please pls plz any best good new nice cheap cheapest price prices how much is are ' +
    'do you have u got that which can one bade baddi badde 3andak 3andkon fi fe shi chi kif ade adesh addesh ' +
    'بدي عندك عندكن في شي اريد أريد ابحث عن من على مع ال لل').split(/\s+/);
  var STOPSET = {}; STOP.forEach(function (w) { STOPSET[w] = 1; });

  // canonical term -> list of variants (english misspellings, franco, arabic, french)
  var SYN = {
    iphone: ['ayfon', 'aifon', 'ifone', 'iphon', 'ifon', 'ايفون', 'آيفون', 'افون'],
    samsung: ['samsong', 'samsun', 'sumsung', 'سامسونج', 'سامسونغ'],
    galaxy: ['galaxi', 'جالاكسي', 'غالاكسي'],
    xiaomi: ['xaomi', 'shaomi', 'chaomi', 'xiomi', 'شاومي'],
    redmi: ['ريدمي'],
    huawei: ['hawawi', 'huawi', 'huwawei', 'هواوي'],
    honor: ['honour', 'هونر'],
    apple: ['aple', 'ابل', 'آبل'],
    airpods: ['airpod', 'airbods', 'erpods', 'irpods', 'ايربودز', 'ايربود'],
    earbuds: ['earbud', 'earphones', 'earphone', 'buds', 'ecouteur', 'ecouteurs', 'سماعة', 'سماعات', 'samma3a', 'sama3a', 'sama3at'],
    headphones: ['headphone', 'headset', 'casque', 'over ear', 'سماعة راس', 'سماعه'],
    charger: ['chargeur', 'charging', 'adapter', 'adaptor', 'plug', 'شاحن', 'charjer', 'sharger', 'chahen', 'sha7en'],
    cable: ['cabel', 'cord', 'wire', 'شريط', 'كابل', 'كبل', 'cble'],
    powerbank: ['power bank', 'batterie', 'battery pack', 'باور بانك', 'باوربانك', 'بطارية', 'battarye', 'battariye'],
    watch: ['watches', 'smartwatch', 'montre', 'ساعة', 'ساعه', 'sa3a', 'se3a'],
    band: ['strap', 'bracelet', 'سوار', 'kesteik', 'kastek', 'كستيك'],
    phone: ['phones', 'mobile', 'mobiles', 'telephone', 'tel', 'cell', 'هاتف', 'تلفون', 'تليفون', 'جوال', 'موبايل', 'telefon', 'talafon'],
    tablet: ['tab', 'tabs', 'tablette', 'تابلت', 'ايباد', 'ipad'],
    ipad: ['ايباد', 'aypad', 'ipaad'],
    carplay: ['car play', 'apple carplay', 'wireless carplay', 'android auto', 'كاربلاي', 'كار بلاي'],
    car: ['voiture', 'auto', 'سيارة', 'سياره', 'sayara', 'siyara'],
    speaker: ['speakers', 'enceinte', 'سبيكر', 'سماعة بلوتوث', 'baffle'],
    router: ['wifi', 'modem', 'راوتر', 'رواتر', 'internet'],
    camera: ['cam', 'cctv', 'كاميرا', 'kamera', 'camira'],
    microphone: ['mic', 'mike', 'micro', 'ميكروفون', 'مايك', 'ميك'],
    glasses: ['sunglasses', 'lunettes', 'نظارة', 'نظارات', 'naddara', 'nadara'],
    protector: ['screen protector', 'glass', 'tempered', 'لزقة', 'سكرين', 'screen'],
    case: ['cover', 'coque', 'كفر', 'جراب', 'kfer', 'kafar'],
    console: ['playstation', 'ps5', 'nintendo', 'switch', 'xbox', 'gaming', 'بلايستيشن', 'بلاستيشن'],
    tracker: ['airtag', 'smart tag', 'smarttag', 'tag'],
    vacuum: ['vacuum cleaner', 'مكنسة', 'aspirateur'],
    dryer: ['hair dryer', 'sechoir', 'سشوار', 'استشوار'],
    tvbox: ['tv box', 'android box', 'mi box', 'streamer', 'chromecast', 'tv stick'],
    fitness: ['fit', 'smart band', 'smartband', 'fitness band', 'fitness tracker', 'activity tracker', 'smart bracelet']
  };

  function stripAccents(s) { return s.normalize ? s.normalize('NFD').replace(/[̀-ͯ]/g, '') : s; }
  function normArabic(s) {
    return s.replace(/[ً-ٟـ]/g, '')       // harakat + tatweel
      .replace(/[إأآا]/g, 'ا').replace(/ى/g, 'ي').replace(/ة/g, 'ه').replace(/ؤ/g, 'و').replace(/ئ/g, 'ي');
  }
  function norm(s) {
    s = stripAccents(String(s || '').toLowerCase());
    s = normArabic(s);
    s = s.replace(/<[^>]*>/g, ' ').replace(/&[a-z]+;/g, ' ');
    s = s.replace(/(\d)\s*(gb|tb|mah|w|mm)\b/g, '$1$2');
    s = s.replace(/\bgalaxy([a-z])(\d)/g, 'galaxy $1$2').replace(/\bip(\d)/g, 'iphone $1').replace(/\bip\b/g, 'iphone');
    s = s.replace(/(\d)([a-z]{2,})/g, function (m, d, w) { return /^(gb|tb|mah|mm|th|nd|rd|st|hz)$/.test(w) ? m : d + ' ' + w; }); // "18promax" -> "18 promax"
    s = s.replace(/([a-z]{3,})(\d)/g, '$1 $2');                    // "iphone18" -> "iphone 18"
    s = s.replace(/\bpromax\b/g, 'pro max').replace(/\bpromx\b/g, 'pro max').replace(/\bpm\b/g, 'pro max').replace(/\bproplus\b/g, 'pro plus')
         .replace(/\bairpodspro\b/g, 'airpods pro').replace(/\bairpodsmax\b/g, 'airpods max').replace(/\bapplewatch\b/g, 'apple watch')
         .replace(/\bwatchultra\b/g, 'watch ultra').replace(/\bipadpro\b/g, 'ipad pro').replace(/\bipadair\b/g, 'ipad air').replace(/\bmacbookair\b/g, 'macbook air')
         .replace(/\bpowerbank\b/g, 'power bank').replace(/\bplaystation(\d)/g, 'playstation $1').replace(/\bps\s?([2-5])\b/g, 'playstation $1');           // "256 gb" -> "256gb"
    s = s.replace(/[^a-z0-9؀-ۿ$.]+/g, ' ').replace(/\s+/g, ' ').trim();
    return s;
  }
  function tokens(s) { return norm(s).split(' ').filter(Boolean); }

  // variant -> canonical map (multi-word variants handled as phrases)
  var VAR = {}, PHRASES = [];
  Object.keys(SYN).forEach(function (canon) {
    SYN[canon].concat([canon]).forEach(function (v) {
      var nv = norm(v);
      if (nv.indexOf(' ') >= 0) PHRASES.push([nv, canon]); else (VAR[nv] = VAR[nv] || []).push(canon);
    });
  });
  PHRASES.sort(function (a, b) { return b[0].length - a[0].length; });

  function lev(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = [], cur, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i]; var rowMin = i;
      for (j = 1; j <= b.length; j++) {
        var c = a[i - 1] === b[j - 1] ? 0 : 1;
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + c);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) cur[j] = Math.min(cur[j], prev[j - 2 + 0] + 0 + 1);
        if (cur[j] < rowMin) rowMin = cur[j];
      }
      if (rowMin > max) return max + 1;
      prev = cur;
    }
    return prev[b.length];
  }

  // Parse query: price intent, phrases, synonyms
  function parseQuery(q) {
    var n = norm(q), res = { min: null, max: null, sort: null, groups: [] };
    var m;
    if ((m = n.match(/(?:under|below|less than|max|up to|taht|ta7t|tahet|ma bi|تحت|اقل من|أقل من)\s*\$?\s*(\d+)/))) { res.max = +m[1]; n = n.replace(m[0], ' '); }
    if ((m = n.match(/(?:over|above|more than|min|fo2|fawe2|فوق|اكثر من)\s*\$?\s*(\d+)/))) { res.min = +m[1]; n = n.replace(m[0], ' '); }
    if ((m = n.match(/(\d+)\s*(?:to|-|و|la)\s*(\d+)\s*\$/))) { res.min = +m[1]; res.max = +m[2]; n = n.replace(m[0], ' '); }
    n = n.replace(/\$\s*(\d+)|(\d+)\s*\$/g, function (_, a, b) { res.max = res.max || +(a || b); return ' '; });
    if (/\b(cheap|cheapest|rkhis|r5ees|ar5as|arkhas|رخيص|ارخص)\b/.test(n)) res.sort = 'price';
    // phrases -> canonical
    PHRASES.forEach(function (p) {
      var re = new RegExp('(^| )' + p[0].replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '( |$)', 'g');
      if (re.test(n)) { res.groups.push({ raw: p[0], alts: [p[1], p[0].replace(/ /g, '')] }); n = n.replace(re, ' '); }
    });
    var toks = n.split(' ').filter(Boolean);
    toks.forEach(function (t, i) {
      if (STOPSET[t] || !/[a-z0-9\u0600-\u06ff]/.test(t)) return;
      var alts = [t];
      if (VAR[t]) alts = alts.concat(VAR[t]);
      // joined with next token ("car play" -> "carplay", "air pods")
      if (toks[i + 1]) alts.push(t + toks[i + 1]);
      res.groups.push({ raw: t, alts: alts });
    });
    return res;
  }

  // Build searchable index for a product (from /products.json shape)
  function indexProduct(p) {
    var tags = (p.tags || []).filter(function (t) { return !/^color-|^storage-|^size-/.test(t); })
      .map(function (t) { return t.replace(/^(acc|cat|brand|phones|tabs|watches)-/, '').replace(/-/g, ' '); });
    var colors = (p.tags || []).filter(function (t) { return /^color-/.test(t); }).map(function (t) { return (t.split(':')[1] || ''); });
    var title = norm(p.title);
    var meta = norm([p.product_type, p.vendor].concat(tags, colors).join(' '));
    var body = norm(p.body_html || '').slice(0, 3000);
    var prices = (p.variants || []).map(function (v) { return parseFloat(v.price); }).filter(function (x) { return x > 0; });
    var askPrice = (p.tags || []).indexOf('ask-price') >= 0;
    // expand synonyms into the index so arabic/franco queries hit english titles
    var words = (title + ' ' + meta).split(' '), extra = [];
    words.forEach(function (w) { if (VAR[w]) extra = extra.concat(VAR[w]); });
    return {
      p: p, title: title, titleWords: title.split(' '), titleJoined: title.replace(/ /g, ''),
      meta: meta + ' ' + extra.join(' '), metaWords: (meta + ' ' + extra.join(' ')).split(' '),
      body: body, price: askPrice || !prices.length ? null : Math.min.apply(null, prices)
    };
  }

  function wordHit(alt, words, joined) {
    var best = 0;
    for (var i = 0; i < words.length; i++) {
      var w = words[i];
      if (w === alt) return 1;
      if (alt.length >= 3 && w.indexOf(alt) === 0 && (alt.length >= 4 || w.length - alt.length <= 2)) best = Math.max(best, 0.85);
      else if (alt.length >= 4 && w.indexOf(alt) > 0) best = Math.max(best, 0.6);
      else if (alt.length >= 5 && w.length >= 4 && /^[a-z]+$/.test(alt)) {
        var d = lev(alt, w, alt.length >= 7 ? 2 : 1);
        if (d <= (alt.length >= 7 ? 2 : 1)) best = Math.max(best, d === 1 ? 0.7 : 0.55);
      }
    }
    if (best < 1 && joined && alt.length >= 4 && joined.indexOf(alt) >= 0) best = Math.max(best, 0.8);
    return best;
  }

  function score(ix, q) {
    if (!q.groups.length) return 1;
    var total = 0, matched = 0;
    q.groups.forEach(function (g) {
      var s = 0;
      g.alts.forEach(function (a) {
        var t = wordHit(a, ix.titleWords, ix.titleJoined) * 10;
        var m = wordHit(a, ix.metaWords) * 6;
        var b = a.length >= 3 && (' ' + ix.body + ' ').indexOf(' ' + a) >= 0 ? 2 : 0;
        s = Math.max(s, t, m, b);
      });
      if (s > 0) matched++;
      total += s;
    });
    var need = q.groups.length <= 2 ? q.groups.length : Math.ceil(q.groups.length * 0.6);
    if (matched < need) return 0;
    return total + matched * 3 - ix.titleWords.length * 0.15;
  }

  function search(index, query, limit) {
    var q = parseQuery(query), out = [];
    index.forEach(function (ix) {
      if (q.max != null && (ix.price == null || ix.price > q.max)) return;
      if (q.min != null && (ix.price == null || ix.price < q.min)) return;
      var s = score(ix, q);
      if (s > 0) out.push({ ix: ix, s: s });
    });
    var ACC = /\b(case|cases|cover|covers|charger|chargers|charging|cable|cables|adapter|magsafe|glass|protector|band|bands|strap|straps|holder|stand|pen|pencil|lens|skin|grip|grips|hook|bag|sleeve|power ?bank|battery|accessor(y|ies))\b/i;
    var DEV = /^(phone|phones|tablet|smart ?watch|smartwatch|laptop|game console|headphones|earbuds|earphones|fitness band|camera|instant camera|speaker|smart speaker|monitor|smart glasses|vr headset|electric scooter|gimbal|projector)$/i;
    var wantAcc = ACC.test(String(query || '').replace(/smart ?band|fitness band|smart bracelet/gi, ' '));
    function bucket(r) {
      if (wantAcc) return 0;
      var t = String((r.ix.p && r.ix.p.title) || '');
      if (DEV.test(String((r.ix.p && r.ix.p.product_type) || '').trim())) return 0;
      return ACC.test(t) ? 2 : 1;
    }
    function modelNo(r) { var m = String((r.ix.p && r.ix.p.title) || '').match(/(\d{1,2})(?!\d)/); return m ? +m[1] : 0; }
    var wantFit = q.groups.some(function (g) { return g.alts.indexOf('fitness') >= 0; });
    if (wantFit) { out.forEach(function (r) { var p = r.ix.p || {}; if (/fitness/i.test((p.product_type || '') + ' ' + (p.tags || []).join(' ') + ' ' + (p.title || ''))) { r.s += 20; r.fit = 1; } }); out = out.filter(function (r) { return r.fit || /smart ?watch/i.test(String((r.ix.p && r.ix.p.product_type) || '')); }); }
    var maxS = 0; out.forEach(function (r) { if (r.s > maxS) maxS = r.s; });
    out.sort(function (a, b) {
      if (q.sort === 'price') return (a.ix.price || 1e9) - (b.ix.price || 1e9);
      var sa = a.s >= maxS * 0.75 ? 1 : 0, sb = b.s >= maxS * 0.75 ? 1 : 0;
      if (sa !== sb) return sb - sa;
      var ba = bucket(a), bb = bucket(b);
      if (ba !== bb) return ba - bb;
      if (ba === 0 && !wantAcc) return modelNo(b) - modelNo(a) || b.s - a.s;
      return b.s - a.s || (a.ix.price == null) - (b.ix.price == null);
    });
    return { query: q, results: out.slice(0, limit || 48).map(function (r) { return r.ix.p; }) };
  }

  var api = { norm: norm, parseQuery: parseQuery, indexProduct: indexProduct, search: search };
  root.SSSmart = api;
})(window);

/* SSQ layer: same public API as before (window.SSQ.load / search / money) */
(function () {
  if (window.SSQ) return;
  var S = window.SSSmart;
  var CAT = { tab: 'tabs', tabs: 'tabs', tablet: 'tabs', tablets: 'tabs', 'تابلت': 'tabs', ipads: 'tabs',
    phone: 'phones', phones: 'phones', mobile: 'phones', mobiles: 'phones', smartphone: 'phones', smartphones: 'phones',
    'موبايل': 'phones', 'تلفون': 'phones', 'تليفون': 'phones', 'هاتف': 'phones',
    watch: 'watches', watches: 'watches', smartwatch: 'watches', smartwatches: 'watches', 'ساعه': 'watches', 'ساعة': 'watches' };
  function inCat(p, c) {
    var t = p.tags, ty = (p.product_type || '').toLowerCase(), ti = S.norm(p.title);
    if (t.indexOf('cat-' + c) > -1) return true;
    if (c === 'tabs') return /tablet/.test(ty) && !/holder|stand|case|keyboard|cover|pencil|tips|folio|accessor|protector|sleeve|bag/.test(ti) && !/accessor/.test(ty);
    if (c === 'phones') return /^(phone|smartphone|mobile)/.test(ty);
    if (c === 'watches') return (/watch/.test(ty) || /\bwatch\b/.test(ti)) && !/band|strap|charger|cable|dock|case|loop|protector|stand/.test(ti);
    return false;
  }
  function strip(h) { return String(h || '').replace(/<[^>]*>/g, ' ').replace(/&[a-z#0-9]+;/gi, ' ').replace(/\s+/g, ' ').slice(0, 600); }
  var cat = null;
  function load() {
    if (cat) return cat;
    try {
      var c = JSON.parse(sessionStorage.getItem('ssq_cat7') || 'null');
      if (c && Date.now() - c.t < 6e5) return (cat = Promise.resolve(c.d));
    } catch (e) {}
    cat = (async function () {
      for (var all = [], pg = 1; pg < 20; pg++) {
        var r = await fetch('/products.json?limit=250&page=' + pg).then(function (r2) { return r2.json(); });
        all = all.concat(r.products || []);
        if (!r.products || r.products.length < 250) break;
      }
      var d = all.map(function (x) {
        var v = (x.variants || [])[0] || {};
        var colors = (x.tags || []).filter(function (s) { return /^color-\d/i.test(s); }).map(function (s) { return s.split(':')[1] || ''; });
        return {
          id: x.id, title: x.title, handle: x.handle, vendor: x.vendor || '', product_type: x.product_type || '',
          tags: (x.tags || []).map(function (s) { return s.toLowerCase(); }).filter(function (s) { return !/^(color|model|storage|size)-\d/.test(s); }),
          colors: colors.join(' '),
          body: strip(x.body_html),
          img: (x.images && x.images[0] && x.images[0].src) || '',
          price: v.price, cmp: v.compare_at_price,
          avail: (x.variants || []).some(function (v2) { return v2.available; })
        };
      });
      try { sessionStorage.setItem('ssq_cat7', JSON.stringify({ t: Date.now(), d: d })); } catch (e) {}
      return d;
    })();
    return cat;
  }
  var ixCache = null, ixSrc = null;
  function index(list) {
    if (ixSrc === list) return ixCache;
    ixSrc = list;
    ixCache = list.map(function (p) {
      var ix = S.indexProduct({
        title: p.title, product_type: p.product_type, vendor: p.vendor,
        tags: p.tags.concat(p.colors ? ['color-x:' + p.colors] : []),
        body_html: p.body,
        variants: [{ price: p.tags.indexOf('ask-price') > -1 ? '0' : p.price }]
      });
      ix.p = p;
      return ix;
    });
    return ixCache;
  }
  function search(q, list) {
    var n = S.norm(q);
    if (!n) return [];
    var w = n.split(' ');
    if (w.length === 1 && CAT[w[0]]) {
      return list.filter(function (p) { return inCat(p, CAT[w[0]]); })
        .sort(function (a, b) { return (b.tags.indexOf('ask-price') > -1) - (a.tags.indexOf('ask-price') > -1) || b.avail - a.avail; });
    }
    var res = S.search(index(list), q, 200).results;
    if (!res.length) {
      // last resort: drop the least-matching words one by one and try again
      var g = w.filter(function (x) { return x.length > 2; });
      while (!res.length && g.length > 1) { g.pop(); res = S.search(index(list), g.join(' '), 200).results; }
    }
    // precision pass: keep only items whose title / brand / type / tags contain the most query words
    (function () {
      var toks = n.split(' ').filter(function (t) { return t.length > 1 || /\d/.test(t); });
      if (!toks.length || !res.length) return;
      if (/smart ?band|fitness (band|tracker)|activity tracker|smart bracelet/.test(n)) return;
      function words(p) { return S.norm([p.title, p.vendor, p.product_type, (p.tags || []).join(' ')].join(' ')).split(/[^a-z0-9]+/); }
      function hit(ws, t) { for (var i = 0; i < ws.length; i++) { var w = ws[i]; if (!w) continue; if (w === t) return 1; if (/^\d+$/.test(t)) continue; if (t.length >= 2 && w.indexOf(t) === 0) return 1; if (t.length >= 4 && w.length >= 4 && t.indexOf(w) === 0 && w.length >= t.length - 2) return 1; } return 0; }
      var best = 0, sc = res.map(function (x) { var ws = words(x.p || x), c = 0; toks.forEach(function (t) { c += hit(ws, t); }); if (c > best) best = c; return c; });
      if (!best) return;
      res = res.filter(function (x, i) { return sc[i] === best; });
    })();
    if (res.length && res.every(function (x) { var p = x.p || x; return p.vendor && S.norm(p.vendor) === n; })) {
      var DEVT = /^(phone|phones|tablet|smart ?watch|smartwatch|laptop|game console)$/i; res = res.slice().sort(function (a, b) { var pa = a.p || a, pb = b.p || b; var da = DEVT.test(String(pa.product_type || '').trim()) ? 0 : 1, db = DEVT.test(String(pb.product_type || '').trim()) ? 0 : 1; return da - db || ((pb.id || 0) - (pa.id || 0)); });
    }
    return res;
  }
  function money(p) { return p.tags.indexOf('ask-price') > -1 ? 'Ask for price' : p.price ? '$' + Number(p.price).toFixed(2) : ''; }
  window.SSQ = { load: load, search: function (q) { return load().then(function (l) { return search(q, l); }); }, money: money };
})();
